import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import { IInterpreterService } from 'models/services/interpreter-service/IInterpreterService';

interface IProps {
  open: boolean;
  onClose: () => void;
  phoneNumbers: IInterpreterService[];
}

const InterpreterNumbersModal: React.FC<IProps> = ({ open, onClose, phoneNumbers }) => {
  const [copiedRow, setCopiedRow] = React.useState<string | null>(null);

  const copyToClipboard = (text: string) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          maxWidth: '90vw',
          width: 'fit-content',
        },
      }}
    >
      <DialogTitle>Interpreter Numbers</DialogTitle>
      <DialogContent dividers>
        <Table
          size="small"
          sx={{
            '& td': { borderBottom: 'none', backgroundColor: 'transparent' },
          }}
        >
          <TableBody>
            {phoneNumbers.map(item => (
              <TableRow key={`${item.service_group_name}-${item.interpreter_phone}`}>
                <TableCell sx={{ width: 200, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  {item.service_group_name || 'All'}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {(() => {
                    const rowKey = `${item.service_group_name}-${item.interpreter_phone}`;
                    const isCopied = copiedRow === rowKey;
                    return (
                      <Tooltip title={isCopied ? 'Copied!' : 'Copy to clipboard'} arrow>
                        <span
                          style={{ cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={e => {
                            e.stopPropagation();
                            copyToClipboard(item.interpreter_phone || '');
                            setCopiedRow(rowKey);
                            setTimeout(() => setCopiedRow(null), 1500);
                          }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              copyToClipboard(item.interpreter_phone || '');
                              setCopiedRow(rowKey);
                              setTimeout(() => setCopiedRow(null), 1500);
                            }
                          }}
                        >
                          {item.interpreter_phone}
                        </span>
                      </Tooltip>
                    );
                  })()}
                  {` – ${item.interpreter_account_number || '–'} – ${item.interpreter_pin || '–'}`}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InterpreterNumbersModal;
